<template>
  <article class="extra">
    <div class="image" :style="{ backgroundImage: 'url(' + featuredImage + ')' }">
      <router-link :to="{name: 'Post', params: {slug: extra.slug}}"></router-link>
    </div>
    <div class="content">
      <router-link :to="{name: 'Post', params: {slug: extra.slug}}"><h2 v-html="extra.title"></h2></router-link>
      <p class="meta">
        <span>{{ formattedDate }}</span>
        <span v-if="extra.topics">• 
          <span v-for="(topic, index) in extra.topics">
            <router-link :to="{name: 'Extras', query: { topic: topic.slug }}" v-html="topic.name"></router-link><span v-if="index + 1 !== extra.topics.length">, </span>
          </span>
        </span>
      <p><span v-html="extra.excerpt"></span> <router-link :to="{ name: 'Post', params: { slug: extra.slug } }" class="more-link">More</router-link></p>
      <v-waypoint v-if="index === 6" @waypoint="$parent.handleScroll"></v-waypoint>
    </div>
  </article>
</template>

<script>
export default {
  name: 'extra',
  props: ['extra', 'index'],
  computed: {
    formattedDate () {
      return this.$moment(this.extra.date).format('MM.DD.YY')
    },
    featuredImage () {
      let vm = this
      let image = vm.extra.image.large
      if (process.env.NODE_ENV === 'development') {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
      }
      return image
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  $sectionColor: $yellow

  article.extra
    border-top: solid 8px $sectionColor
    background: #ffffff
    margin: 0 15px 30px
    +tablet
      display: flex
      margin: 0 0 34px
      padding: 28px
    h2
      font-size: 24px
      font-weight: bold
      margin-bottom: 0.15em
      +tablet
        font-size: 28px
      &:hover
        color: lighten($textColor, 25%)
    p
      +tablet
       font-size: 18px
       line-height: 28px
      &.meta
        font-weight: bold
        letter-spacing: 0.5px
        margin-bottom: 0.55em
        +tablet
          font-size: 18px
          line-height: 22px
        a
          color: inherit
          &:hover
            color: lighten($textColor, 25%)
    .image
      background: $sectionColor
      background-size: cover
      background-position: center center
      position: relative
      display: block
      width: 100%
      +until($tablet)
        height: 0
        padding-top: 56.25%
        margin-bottom: 10px
      +tablet
        margin-right: 56px
        width: 248px
        height: 148px
      a
        position: absolute
        top: 0
        left: 0
        right: 0
        bottom: 0
        &:hover
          background: rgba(255,255,255,0.10)
    .content
      flex: 1
</style>



// WEBPACK FOOTER //
// Extra.vue?79b5a848